import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { localStorageColorSchemeManager, MantineProvider, useComputedColorScheme } from '@mantine/core'
import { DatesProvider } from '@mantine/dates'
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from '@mantine/notifications'
import AppBridgeProvider from './contexts/AppBridgeProvider'
import { AppProvider } from './contexts/AppContext'
import { AuthProvider } from './contexts/AuthContext'
import { cssVariablesResolver, theme } from './theme'

import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import 'react-toastify/dist/ReactToastify.css'

import AgAppShell from '@/components/organisms/AppShell'
import { FlowProvider } from '@/contexts/FlowContext'

import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/700.css'

// Stable manager without cross-tab storage event sync.
// Other tabs forcing dark mode (login/public page) fire storage events
// that snap the color scheme back — disabling the subscription prevents this.
const baseManager = localStorageColorSchemeManager()
const colorSchemeManager = {
  ...baseManager,
  subscribe: () => {},
  unsubscribe: () => {},
}

// Toast container that respects color scheme
function ThemedToastContainer() {
  const colorScheme = useComputedColorScheme('dark')
  return <ToastContainer position="top-right" autoClose={5000} theme={colorScheme} style={{ zIndex: 10000 }} />
}

export default function App() {
  return (
    <MantineProvider
      theme={theme}
      cssVariablesResolver={cssVariablesResolver}
      defaultColorScheme="dark"
      colorSchemeManager={colorSchemeManager}
    >
      <Notifications position="top-right" />
      <ThemedToastContainer />
      <ModalsProvider>
        <DatesProvider settings={{ locale: 'en', firstDayOfWeek: 1 }}>
          <AuthProvider>
            <AppProvider>
              <FlowProvider>
                <AppBridgeProvider>
                  <BrowserRouter>
                    <AgAppShell />
                  </BrowserRouter>
                </AppBridgeProvider>
              </FlowProvider>
            </AppProvider>
          </AuthProvider>
        </DatesProvider>
      </ModalsProvider>
    </MantineProvider>
  )
}
